import qs from 'qs';
import ssoUtil from '../utils/sso.js';
import Cookies from 'js-cookie';
import Vue from 'vue';

interface CustomWindow extends Window {
    __API_DOMAIN__: string;
}

let { SSO_HOST, SERVER_HOST, SSO_CLIENTID } = window as any;
export default {
    // eslint-disable-next-line
    baseURL: (window as CustomWindow).__API_DOMAIN__,
    // // 请求前的数据处理 加了这个函数，不会对data进行序列化，如果需要使用这个函数，请手动序列化！！！！！！！
    // transformRequest: [(data: any) => {
    //     return data;
    // }],
    // 请求后的数据处理
    // TODO interceptors 处理 http 非200 错误
    transformResponse: [(data: any, ...arg) => {
        // 对 data 进行任意转换处理
        if (!data) {
            return data;
        }
        // 对于sso登陆失败直接转跳
        if (data.status === 401) {
            ssoUtil.redirect();
        }
        // 对于已经登录但是权限不足的用户的错统一拦截处理

        // if (!data.data.username) {
        //     data = {
        //         "code": 412,
        //         "message": "Too many visits from current user"
        //     };
        // }
        if (data.code === 412 && data.message === 'Too many visits from current user') {
            Vue.prototype.$message.error('您当天查询次数已达上限（100次），暂不可以再进行查询');
        }

        // 小白用户情况
        if (data.message === 'invalid permission') {
            (document.querySelector('#app') as any).style.opacity = .7;
            setTimeout(() => {alert('您无权使用该系统')}, 100);
        }

        // 白名单 但是非管理员情况 金融图谱特殊处理
        if (data.message === 'no sufficient privilege') {
            if (location.href.indexOf('finance') !== -1) {
                (document.querySelector('#app') as any).style.opacity = .7;
                setTimeout(() => {alert('您无权使用该系统');}, 100);
            } else {
                Vue.prototype.$message.error('您当前无权查看其他用户信息');
            }
        }

        return data;
    }],
    // 自定义的请求头
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'access-token': encodeURIComponent(Cookies.get(`${SSO_CLIENTID}_fe_ssoid`)) || ''
        // 'Content-Type': 'abc',
    },
    // // 查询对象序列化函数
    paramsSerializer: function(params: any) {
        return qs.stringify(params);
    },
    // 超时设置s
    timeout: 300000,
    // 跨域是否带Token
    // withCredentials: true,
    // 响应的数据格式 json / blob /document /arraybuffer / text / stream
    responseType: 'json',
    // XSRF 设置
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    // 最多转发数，用于node.js
    maxRedirects: 5,
    // 最大响应数据大小
    maxContentLength: 2000,
    // 自定义错误状态码范围
    validateStatus: function(status: any) {
        return status >= 200 && status < 300;
    }
};
